import * as MuiIcons from '@mui/icons-material';

export function HeartIcon({ filled = false, animated = false, size = 28, style = {}, ...props }) {
  const IconComp = filled ? MuiIcons.Favorite : MuiIcons.FavoriteBorder;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        transition: animated ? 'transform 0.2s' : undefined,
        transform: animated && filled ? 'scale(1.2)' : 'scale(1)',
        color: filled ? '#e53935' : '#888',
        ...style,
      }}
      {...props}
    >
      <IconComp style={{ fontSize: size, transition: 'color 0.2s' }} />
    </span>
  );
}
